// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"e2f72be3","226":"811e8d1e","268":"0afb3c3f","581":"67a51924","601":"d46bba5b","787":"185d9fbd"}[chunkId] + ".chunk.js";
};